import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_DRIVERS_DOCUMENTS_DATA } from "./actionTypes";
import {
  fetchDriversDocumentsSuccess,
  fetchDriversDocumentsFailure,
} from "./actions";

function* fetchDriversDocumentsDataSaga(data) {
  try {
    let url = process.env.REACT_APP_WEB_APP_URL + `/api/web/drivers-documents`;
    if (data.driverId) {
      url += `?driverId=${data.driverId}`;
    }
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchDriversDocumentsSuccess(response.data));
  } catch (error) {
    yield put(fetchDriversDocumentsFailure(error.message));
  }
}

export default function* driversDocumentsSaga() {
  yield takeEvery(FETCH_DRIVERS_DOCUMENTS_DATA, fetchDriversDocumentsDataSaga);
}
